import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import DriverStoreMappingsApi from "../../services/api/DriverStoreMappings";

const handleError = (err) => {
  console.log("[DriverStoreMappings] Error in fetching upload url", err);
};

export const getUploadUrl = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await DriverStoreMappingsApi.getUploadUrl(payload);
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
